import { Component, OnInit } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import {
    ECloseService,
    IClientECloseOptionData,
} from 'app/modules/production/services/eClose.service';
import { ToastService } from 'app/modules/shared/services/toast.service';

@Component({
    selector: 'app-e-close-roi-settings',
    templateUrl: './e-close-roi-settings.component.html',
    styleUrls: ['./e-close-roi-settings.component.scss'],
})
export class ECloseRoiSettingsComponent implements OnInit {
    constructor(private eCloseService: ECloseService, private toast: ToastService) {}
    gridData: GridDataResult;
    clientECloseData: IClientECloseOptionData[];
    hasErrors: boolean = false;

    ngOnInit(): void {
        this.loadData();
    }

    loadData() {
        this.eCloseService.getClientECloseOptions().subscribe(
            (data) => {
                this.clientECloseData = data;
                this.prepareGrid();
            },
            (error) => {
                console.log('error: ', error);
            }
        );
    }

    prepareGrid() {
        this.gridData = {
            data: this.clientECloseData,
            total: this.clientECloseData.length,
        };
    }

    saveOptions() {
        this.eCloseService.updateClientECloseOptions(this.clientECloseData).subscribe(
            (data) => {
                this.toast.success('ROI Settings Updated Successfully.');
                this.loadData();
            },
            (error) => {
                console.log('error: ', error);
            }
        );
    }

    updateInput(value, dataItem) {
        dataItem.error = false;
        this.hasErrors = false;
        if (value > 1000) {
            dataItem.error = true;
            this.hasErrors = true;
        }
        const num = value.replace(/[$,]/g, '');
        return Number(num);
    }
}
